<template>
	<footer>
		<div class="container">
			<div class="footer">
				<div class="left-footer">
					<ul>
						<li class="merchantrade-logo">
							<a href="https://mtradeasia.com/" target="_blank">
							<img src="/static/img/merchantrade.png" alt=""/></a>
						</li>
					</ul>
				</div>
				<div class="right-footer">
					<ul>
						<li>
							<a href="https://www.digicert.com/" target="_blank">
							<img src="/static/img/digicert.png" alt=""/>
							</a>	
						</li>
						<li>
								<a href="https://www.mamsb.org.my/" target="_blank">
							<img src="/static/img/logo-mamsb-with-text.png" alt=""/>
							</a>
						</li>
						<li>
								<a href="https://www.iamtn.org/" target="_blank">
							<img src="/static/img/iamtn.png" alt=""/>
							</a>
						</li>
						<li>
								<a href="https://www.paynet.my/" target="_blank">
							<img src="/static/img/fpx.png" alt=""/>
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="copyright">
				<p>Copyright ©{{currentYear}}. Merchantrade Asia Sdn. Bhd. 199601038238 (410591-T). All Rights Reserved.</p>
			</div>
		</div>
	</footer>
</template>


<script>

	export default {
		computed: {
			currentYear() {
				return new Date().getFullYear();
			},
		}
	}
</script>
